



















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class TextAreaElement extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: String, required: false }) readonly id!: string;
  @Prop({ type: String, required: false }) readonly value!: string;
  @Prop({ type: String, required: false }) cssClass!: string;
  @Prop({ type: String, required: false }) inputCssClass!: string;
  @Prop({ type: String, required: false }) containerInputCssClass!: string;
  @Prop({ type: String, required: false }) placeholder!: string;
  @Prop({ type: String, required: false }) maxlength!: number;

  get inputListeners() {
    return {
      ...this.$listeners,
      input: (event: any) => {
        this.$emit("input", event.target.value);
      },
    };
  }
}
